import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ImageIllustration = function ImageIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ImageIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M20 16a2 2 0 0 1 2-2h68a2 2 0 0 1 2 2v34a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2z",
      opacity: ".3"
    }), jsxs("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".5",
      children: [jsx("path", {
        d: "M47.29 21.314 22.377 54.806c-.982 1.32-.04 3.194 1.604 3.194h53.04c1.644 0 2.586-1.874 1.604-3.194L53.71 21.314c-1.6-2.15-4.819-2.15-6.418 0"
      }), jsx("path", {
        d: "m69.728 36.861-12.13 18.022c-.894 1.329.058 3.117 1.659 3.117h27.926c1.613 0 2.563-1.812 1.644-3.138L76.335 36.818c-1.603-2.316-5.034-2.294-6.607.043M84.252 24.626a5.626 5.626 0 1 1-11.252 0 5.626 5.626 0 0 1 11.252 0"
      })]
    }), jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".5",
      children: jsx("path", {
        d: "M18 6a6 6 0 0 0-6 6v8a2 2 0 1 0 4 0v-8a2 2 0 0 1 2-2h8a2 2 0 1 0 0-4zM94 6a6 6 0 0 1 6 6v8a2 2 0 1 1-4 0v-8a2 2 0 0 0-2-2h-8a2 2 0 1 1 0-4zM100 60a6 6 0 0 1-6 6h-8a2 2 0 1 1 0-4h8a2 2 0 0 0 2-2v-8a2 2 0 1 1 4 0zM18 66a6 6 0 0 1-6-6v-8a2 2 0 1 1 4 0v8a2 2 0 0 0 2 2h8a2 2 0 1 1 0 4z"
      })
    })]
  }));
};

export { ImageIllustration };
